"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = injectGlobals;
var _aphrodite = require("aphrodite");
var globalExtension = {
  selectorHandler: function selectorHandler(selector, _, generateSubtreeStyles) {
    if (selector[0] !== "#") {
      return null;
    }
    return generateSubtreeStyles(selector.slice(1));
  }
};
var _origStyleSheet$exten = _aphrodite.StyleSheet.extend([globalExtension]),
  StyleSheet = _origStyleSheet$exten.StyleSheet,
  css = _origStyleSheet$exten.css;
function injectGlobals(globalStyles) {
  var prefixedStyles = {};
  Object.keys(globalStyles).forEach(function (key) {
    prefixedStyles["#" + key] = globalStyles[key];
  });
  var styles = StyleSheet.create({
    global: prefixedStyles
  });
  css(styles.global);
}